import { EnvironmentVariablesError } from '../errors/shared';

export const jsonResponse = <T>(data: T, status: number = 200): Response => {
  return new Response(JSON.stringify(data), {
    status,
    headers: { 'Content-Type': 'application/json' }
  });
};

/**
 * Генерирует url для запроса
 *
 * @param {string} endpoint
 * @returns {string}
 *
 * @throws Не выбрасывает исключения
 *
 *
 */
export const configEndpoint = (endpoint: string): string => {
  const apiUrl = process.env.NEXT_PUBLIC_BASE_URL;
  if (!apiUrl) {
    throw new EnvironmentVariablesError();
  }
  return new URL(endpoint, apiUrl).toString();
};

export const configInternalEndpoint = (endpoint: string): string => {
  const apiUrl = process.env.APP_INTERNAL_URL;

  if (!apiUrl) {
    throw new EnvironmentVariablesError();
  }

  return new URL(endpoint, apiUrl).toString();
};
